import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MainHubService } from '../../services/main-hub.service';

@Component({
  selector: 'app-view-auth',
  templateUrl: './auth.component.html',
})
export class AuthComponent implements OnInit {

  message: string = "";

  constructor(private mainHubService: MainHubService, private router: Router, private activatedRoute: ActivatedRoute) {

  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params["code"]) {
       
        this.mainHubService.mainHubConnected.subscribe((value) => {
          if (value) {
            this.message = "Authorizing...";
            this.mainHubService.createAmeritradeToken(params["code"]).then(response => {
              if (response) {
                this.router.navigate(["/"]);
              }
            });
          }
          
        });
       
      } else {
        this.message = "No code provided.";
      }
    });
   
  }


}
